import React, { Component } from "react";
import styled from "styled-components";
import { Segment, Form, TextArea, Header, Button, Input } from "semantic-ui-react";
import CompleteCase from "../../../../../models/CompleteCase";
import CaseRepository, { EditCaseReminderRequestObject } from "../../../../../common/repository/CaseRepository";
import Result from "../../../../../common/repository/Result";
import { toast } from "../../../../common/Toast";
import DateTimePicker from "../../../../app/DateTimePicker";
import CaseReminderListItem from "./CaseReminderListItem";
import LocalStorage from "../../../../../lib/LocalStorage";
import config from "../../../../../common/repository/config";

const ChildSpacing = styled.div`
      & > div {
        margin: 0 16px 8px 16px;
      }
    `;
interface State {
  loading: boolean;
  instruction: string;
  datetime: string;
  instruction_type: string;
  editing: boolean;
  editingInstructionId: string | null;
  instructionStatus: string
  statusEvidence: any
}
interface Props {
  model: CompleteCase;
  updateModel?(model: CompleteCase): void;
}

class CaseReminders extends Component<Props, State> {
  private caseRepo = new CaseRepository();
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      datetime: "",
      instruction_type: "",
      instruction: "",
      editing: false,
      editingInstructionId: null,
      instructionStatus: "",
      statusEvidence: ""
    };
  }

  // Add  reminder
  caseReminder = () => {
    this.setState({ loading: true }, async () => {
      const { model, updateModel } = this.props;

      let payload: any = {
        case_id: model.getId(),
        instruction: {
          posted_on: this.state.datetime,
          instruction: this.state.instruction,
          instruction_type: this.state.instruction_type,
        },
      };

      if (this.state.editing && this.state.editingInstructionId) {
        payload.instructionId = this.state.editingInstructionId;
      }

      const result = await this.caseRepo.caseReminder(payload);
      console.log(result,"kjjkkj")

      if (result instanceof Result.Success) {
        this.setState(
          {
            loading: false,
            instruction: "",
            datetime: "",
            instruction_type: "",
            editing: false,
            editingInstructionId: null,
          },
          () => {
            const c = result.data as CompleteCase;
            toast.success(
              "Case Instruction updated successfully")
            if (updateModel) updateModel(c)
          }
        );
      } else {
        this.setState({ loading: false }, () => {
          toast.error(result.message || "Something went wrong");
        });
      }
    });
  };
  cancelEdit = () => {
    this.setState({
      instruction: "",
      datetime: "",
      instruction_type: "",
      editing: false,
      editingInstructionId: null,
    });
  };


  editCaseReminder = async (instructionId: string) => {
    this.setState({ loading: true, editing: true, editingInstructionId: instructionId });
    const { model, updateModel } = this.props;

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error("Authentication token is missing.");

      const payload = { caseId: model.getId(), instructionId };
      const response = await fetch(`${config.apiBaseURL}/case/checkEditInstruction`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Edit API Response:", data);

      if (data?.success === "true" && data?.data?.items?.length > 0) {
        const reminder = data.data.items[0];

        this.setState({
          loading: false,
          instruction: reminder.instruction,
          datetime: reminder.postedOn,
          instruction_type: reminder.instructionType,
        });

        toast.success(data.message || "Reminder ready to edit");

        if (updateModel) updateModel(data.data);
      } else {
        this.setState({ loading: false });
        toast.error(data.message || "Reminder not found");
      }

    } catch (error) {
      this.setState({ loading: false });
      toast.error(error instanceof Error ? error.message : "Server error occurred");
    }
  };

  uploadCaseReminder = (instructionId: string, instructionType: string) => {
    this.setState({ loading: true }, async () => {
      const { model, updateModel } = this.props;
      const formData = new FormData();
      formData.append("caseId", model.getId());
      formData.append("instructionId", instructionId);

      formData.append("instruction[instruction_status]", this.state.instructionStatus || "no");

      if (this.state.statusEvidence) {
        formData.append("status_evidence", this.state.statusEvidence);
      }

      const result = await this.caseRepo.UploadCaseReminder(formData);

      if (result instanceof Result.Success) {
        this.setState(
          {
            loading: false,
            instructionStatus: "",
            statusEvidence: null,
            editing: false,
            editingInstructionId: null,
          },
          () => {
            const c = result.data as CompleteCase;
            toast.success("Case Reminder Image updated successfully");
            if (updateModel) updateModel(c);
          }
        );
      } else {
        this.setState({ loading: false }, () => {
          toast.error(result.message || "Something went wrong");
        });
      }
    });
  };

  // Update Reminder
  updateCaseReminder = () => {
    this.setState({ loading: true }, async () => {
      const { model, updateModel } = this.props;

      let payload: any = {
        caseId: model.getId(),
        instructionId: this.state.editingInstructionId,
        instruction: {
          posted_on: this.state.datetime,
          instruction: this.state.instruction,
          instruction_type: this.state.instruction_type,
        },
      };

      const result = await this.caseRepo.UpdateCaseReminder(payload);

      if (result instanceof Result.Success) {
        this.setState(
          {
            loading: false,
            instruction: "",
            datetime: "",
            instruction_type: "",
            editing: false,
            editingInstructionId: null,
          },
          () => {
            const c = result.data as CompleteCase;
            toast.success("Case Instruction updated successfully");
            if (updateModel) updateModel(c);
          }
        );
      } else {
        this.setState({ loading: false }, () => {
          toast.error(result.message || "Failed to update instruction");
        });
      }
    });
  };

  addMonthsToCurrentDate = (months: number) => {
    let date = new Date(Date.now());
    let d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() !== d) {
      date.setDate(0);
    }
    return date;
  };

  render() {
    const { model, updateModel } = this.props;
    return (
      <Segment basic loading={this.state.loading} style={{ padding: "20px", width: "90%" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
            gap: "24px",
            alignItems: "flex-start",
          }}
        >
          {/* Left Section - Form */}
          <div
            style={{
              background: "#fff",
              padding: "24px",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              width: "100%",
            }}
          >
            <Form>
              {/* Form Heading */}
              <Header as="h3" style={{ marginBottom: "24px" }}>
                {this.state.editing ? "Edit Reminder" : "Add New Instruction"}
              </Header>
              {/* Date Time Picker */}
              <Form.Field style={{ marginBottom: "20px" }}>
                <label style={{ fontWeight: 500 }}>Date & Time</label>
                <DateTimePicker
                  type="datetime"
                  value={this.state.datetime}
                  maxDate={this.addMonthsToCurrentDate(2)}
                  onChange={(value) => this.setState({ datetime: value })}
                // style={{ width: "100%" }}
                />
              </Form.Field>
              {/* Instruction Type Dropdown */}
              <Form.Field style={{ marginBottom: "20px" }}>
                <label style={{ fontWeight: 500 }}>Instruction Type</label>
                <Form.Dropdown
                  selection
                  placeholder="Select type"
                  options={[
                    { key: "update", text: "Update", value: "update" },
                    { key: "close", text: "Close", value: "close" },
                  ]}
                  value={this.state.instruction_type}
                  onChange={(_, { value }) =>
                    this.setState({ instruction_type: value as string })
                  }
                  style={{ width: "100%" }}
                />
              </Form.Field>

              {/* Instruction Text Area with heading */}
              <Form.Field style={{ marginBottom: "24px" }}>
                <label style={{ fontWeight: 500 }}>Instruction</label>
                <TextArea
                  placeholder="Enter instruction"
                  value={this.state.instruction}
                  onChange={(_, { value }) =>
                    this.setState({ instruction: value as string })
                  }
                  style={{
                    width: "100%",
                    minHeight: "120px",
                    resize: "vertical",
                  }}
                />
              </Form.Field>

              {/* Buttons */}
              <div style={{ display: "flex", gap: "12px" }}>
                <Button
                  positive
                  fluid
                  onClick={
                    this.state.editing ? this.updateCaseReminder : this.caseReminder
                  }
                  disabled={
                    this.state.loading ||
                    !this.state.datetime ||
                    !this.state.instruction_type ||
                    this.state.instruction.trim().length === 0
                  }
                >
                  {this.state.editing ? "Update" : "Submit"}
                </Button>

                {this.state.editing && (
                  <Button color="grey" fluid onClick={this.cancelEdit}>
                    Cancel
                  </Button>
                )}
              </div>
            </Form>
          </div>
          {/* Right Section - Reminder List */}
          <div
            style={{
              height: "550px",
              overflowY: "auto",
              paddingRight: "8px",
            }}
          >
            <ChildSpacing>
              {model.getInstruction().map((it) => (
                <div
                  key={it.getId()}
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  }}
                >
                  {/* Left side - reminder content */}
                  <div style={{ flex: 1, marginRight: "16px" }}>
                    <CaseReminderListItem
                      model={it}
                      caseModel={model}
                      updateModel={updateModel}
                      caseRepo={this.caseRepo}
                    />

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
                      <Button
                        icon="edit"
                        size="mini"
                        primary
                        onClick={() => this.editCaseReminder(it.getId())}
                      />
                    </div>
                  </div>

                  {/* ✅ Right side - only if instruction type is update */}
                  {it.getInstructionType() === "update" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                        minWidth: "220px",
                        padding: "12px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        background: "#fafafa",
                      }}
                    >
                      <h4 style={{ margin: "0 0 10px 0" }}>Upload Case Instruction Image</h4>

                      {/* File Upload */}
                      <div style={{ marginBottom: "10px" }}>
                        <input
                          type="file"
                          onChange={(e) =>
                            this.setState({
                              statusEvidence: e.target.files ? e.target.files[0] : "",
                            })
                          }
                        />
                      </div>

                      {/* Status Evidence Dropdown */}
                      <Form.Field style={{ marginBottom: "10px" }}>
                        <label>Status Evidence</label>
                        <select
                          value={this.state.instructionStatus}
                          onChange={(e) => this.setState({ instructionStatus: e.target.value })}
                          style={{
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            width: "100%",
                          }}
                        >
                          <option value="">Select...</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                          <option value="not_added">Not Added</option>
                        </select>
                      </Form.Field>

                      {/* Upload Button */}
                      <Button
                        size="tiny"
                        color="teal"
                        value={this.state.statusEvidence}
                        fluid
                        loading={this.state.loading}
                        onClick={() => this.uploadCaseReminder(it.getId(), it.getInstructionType())}
                      >
                        Upload
                      </Button>
                    </div>
                  )}
                </div>
              ))}
            </ChildSpacing>
          </div>
        </div>
      </Segment>

    );
  }
}

export default CaseReminders;
